/* 
 * Descrizione: Registra il service worker e gestisce i messaggi di aggiornamento inviati dallo stesso.
 */

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Nota: il percorso è "/serviceWorker.js" e non "../public/serviceWorker.js"
      navigator.serviceWorker.register('/serviceWorker.js')
        .then((registration) => {
          console.log('Service Worker registrato con successo:', registration);

          // Ascolta i messaggi provenienti dal service worker
          navigator.serviceWorker.addEventListener('message', (event) => {
            if (event.data && event.data.type === 'UPDATE_AVAILABLE') {
              console.log('Aggiornamento disponibile!');
              // Lancia un evento custom per notificare l'app React
              const updateEvent = new Event('swUpdate');
              window.dispatchEvent(updateEvent);
            }
          });
        })
        .catch((error) => {
          console.error('Errore nella registrazione del Service Worker:', error);
        });
    });
  }
}
